import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  cursor: ", ";\n  display: flex;\n  height: inherit;\n  padding: 0 ", "px 0\n    ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   {\n    background-color: ", ";\n    box-shadow: ", ";\n    box-sizing: border-box;\n    height: ", "px;\n    position: relative;\n    width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { withoutProps } from '@scp/ui-shared/core/hoc';
import { Icon } from '@scp/ui-shared/theme/icons';
import { withRippleEffect } from '@scp/ui-shared/theme/ripple-effect';
import { getE2eLabel } from '@scp/ui-shared/components/utils';
import { color, property, size } from '@scp/ui-shared/theme/variables';
import { E2E_BACK_SUFFIX, E2E_CLOSE_SUFFIX, E2E_HEADER_SUFFIX, HEADER_TEXT, HEADER_HEIGHT } from './constants';
import { ContentWrapper, HeaderButton, Heading, SecondaryActions } from './baseComponents';
export var HeaderWrapper = styled.header(_templateObject(), color.background, function (props) {
  return props.hideShadow ? 'none' : property.boxShadow;
}, HEADER_HEIGHT);
export var InnerWrapper = styled.div(_templateObject2(), function (props) {
  return props.onClick || props.href ? 'pointer' : 'default';
}, function (props) {
  return props.noGutter ? 0 : size.gutter;
}, function (props) {
  return props.spaced ? 0 : size.gutterSmall;
});
export var Header = function Header(_ref) {
  var children = _ref.children,
      onClose = _ref.onClose,
      onGoBack = _ref.onGoBack,
      secondaryActions = _ref.secondaryActions,
      primaryActions = _ref.primaryActions,
      headingAs = _ref.headingAs,
      onClick = _ref.onClick,
      linkTo = _ref.linkTo,
      title = _ref.title,
      hideShadow = _ref.hideShadow,
      noGutter = _ref.noGutter,
      dataE2e = _ref.dataE2e;
  var wholeHeaderClickable = !!(onClick || linkTo);
  var clickableProps = wholeHeaderClickable && {
    as: withoutProps(withRippleEffect(linkTo ? Link : 'div'), ['spaced']),
    role: !linkTo ? 'button' : undefined,
    tabIndex: !linkTo ? 0 : undefined,
    onClick: onClick,
    onKeyDown: function onKeyDown(e) {
      if (onClick && (e.key === 'Enter' || e.key === ' ')) {
        onClick();
      }
    },
    title: title,
    to: linkTo
  };
  var dataE2eBackLabel = getE2eLabel(children, E2E_BACK_SUFFIX, dataE2e);
  var dataE2eCloseLabel = getE2eLabel(children, E2E_CLOSE_SUFFIX, dataE2e);
  var dataE2eHeaderLabel = getE2eLabel(children, E2E_HEADER_SUFFIX, dataE2e);
  return React.createElement(HeaderWrapper, {
    hideShadow: hideShadow
  }, React.createElement(InnerWrapper, Object.assign({
    noGutter: noGutter,
    spaced: !wholeHeaderClickable && !!(onGoBack || onClose || primaryActions)
  }, clickableProps), !wholeHeaderClickable && React.createElement(React.Fragment, null, onGoBack && React.createElement(HeaderButton, {
    title: HEADER_TEXT.GO_BACK,
    onClick: onGoBack,
    dataE2e: dataE2eBackLabel
  }, React.createElement(Icon, {
    name: "arrow-back"
  })), onClose && React.createElement(HeaderButton, {
    title: HEADER_TEXT.CLOSE,
    onClick: onClose,
    dataE2e: dataE2eCloseLabel
  }, React.createElement(Icon, {
    name: "close"
  })), primaryActions), React.createElement(ContentWrapper, {
    "data-e2e": dataE2eHeaderLabel
  }, typeof children === 'string' ? React.createElement(Heading, {
    as: headingAs
  }, children) : children), secondaryActions && React.createElement(SecondaryActions, null, secondaryActions)));
};